import React from "react";
import { StyleSheet, Platform, View, Text } from "react-native";
import { Dialog, Portal, Button } from "react-native-paper";
import { COLORS, STRINGS } from "../../constants";

const ParkingDetailDisclaimer = ({ visible, onDismiss, onConfirm }) => {
  return (
    <Portal>
      {visible && (
        <Dialog visible={visible} style={styles.disclaimerContainer}>
          <Dialog.Title style={styles.titleText}>{`${STRINGS.disclaimer}:`}</Dialog.Title>
          <Dialog.Content>
            <View style={styles.disclaimerTextContainer}>
              <Text style={styles.disclaimerText}>{STRINGS.text2PayDisclaimerPhoneLicense}</Text>
              <Text style={styles.disclaimerText}>{STRINGS.text2PayDisclaimerNonGuarantee}</Text>
              <Text style={styles.disclaimerText}>{STRINGS.text2PayDisclaimerReserve}</Text>
            </View>
          </Dialog.Content>
          <Dialog.Actions>
            <Button
              onPress={onDismiss}
              labelStyle={styles.disclaimerText}
              style={styles.disclaimerButton}
              contentStyle={styles.buttonContentStyle}
            >
              {STRINGS.close}
            </Button>
            <Button
              labelStyle={styles.disclaimerText}
              style={styles.disclaimerButton}
              contentStyle={styles.buttonContentStyle}
              onPress={onConfirm}
            >
              {STRINGS.confirm}
            </Button>
          </Dialog.Actions>
        </Dialog>
      )}
    </Portal>
  );
};

const styles = StyleSheet.create({
  disclaimerContainer: {
    transform: [{ translateY: -80 }],
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.warning,
    backgroundColor: COLORS.warningLight,
  },
  disclaimerTextContainer: {
    paddingLeft: Platform.OS === "web" ? 12 : 6,
    gap: 6,
  },
  titleText: {
    color: COLORS.warningText,
  },
  disclaimerText: {
    color: COLORS.warningText,
    fontSize: Platform.OS === "web" ? 16 : 14,
  },
  disclaimerButton: {
    borderRadius: 15,
    borderWidth: 1,
    borderColor: COLORS.warning,
  },
  buttonContentStyle: {
    paddingHorizontal: Platform.OS === "web" ? 8 : 4,
  },
});

export default ParkingDetailDisclaimer;
